module.exports = __webpack_public_path__ + "static/media/plastic-problem-article.be172226.jpg";